import React from 'react'
import {Sheet, SheetContent} from '@retracedgmbh/ui-components-lib'

const Drawer = ({
  onClose,
  isOpen = false,
  children,
  isFlexibleWidth = false,
  hasOverflowYHidden = false,
  overflowY = 'unset',
  zIndex,
  side = 'right',
}) => {
  const overflowStyle = hasOverflowYHidden
    ? 'tw:overflow-y-hidden'
    : overflowY === 'scroll'
      ? 'tw:overflow-y-auto'
      : '';
  const widthStyle = isFlexibleWidth
    ? 'tw:w-auto tw:max-w-none'
    : 'tw:max-w-xl';
  
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent
        side={side}
        className={`${widthStyle} ${overflowStyle}`}
        style={zIndex ? { zIndex } : undefined}
      >
        {children}
      </SheetContent>
    </Sheet>
  );
}

export default Drawer
